/* Skeleton grid that mimics <UpsellOptionCard> layout
   --------------------------------------------------- */
import classNames from 'classnames'

const SkeletonOpt = () => (
  <div className="animate-pulse rounded-sm border-xs border-[#cbcbcb] bg-white p-16">
    <div className="mb-4 h-5 w-2/3 rounded bg-[#e5e5e5]" />
    <div className="mb-2 h-8 w-24 rounded bg-[#e5e5e5]" />
    <div className="h-4 w-20 rounded bg-[#e5e5e5]" />
  </div>
)

export const UpsellOptionsSkeleton = ({ windowSize }) => (
  <div
    className={classNames(
      'grid gap-4',
      windowSize > 980 ? 'grid-cols-2' : 'grid-cols-1'
    )}
  >
    {[0, 1].map(i => (
      <SkeletonOpt key={i} />
    ))}
  </div>
)
